module.exports = __webpack_public_path__ + "img/public/AdminIcons/welcomeHand.png?5d4b49f4";